<div class="cards-details">
  <div class="user-info-grid">
    <div class="user-info-column">
      @if (item?.owner) {
        <div class="item-row">
          <div class="item-wrapper w-145">
            <span class="card-body-icons user-icon"></span>
            <span class="items-text">{{ 'general.participant' | translate}}:</span>
          </div>
          <div class="ml-10 user-data-text">{{ item.owner }}</div>
        </div>
      }
      @if (item?.customerPhone) {
        <div class="item-row">
          <div class="item-wrapper w-145">
            <span class="card-body-icons tel-icon"></span>
            <span class="items-text">{{ 'general.phone' | translate }}:</span>
          </div>
          <div class="ml-10 user-data-text">{{ item.customerPhone }}</div>
        </div>
      }
      @if (item?.customerEmail) {
        <div class="item-row">
          <div class="item-wrapper w-145">
            <span class="card-body-icons email-icon"></span>
            <span class="items-text">{{ 'general.email' | translate }}:</span>
          </div>
          <div class="ml-10 user-data-text">{{ item.customerEmail }}</div>
        </div>
      }
    </div>
    <div class="user-info-column">
      @if (item?.transactionCode) {
        <div class="item-row">
          <div class="item-wrapper w-145">
            <span class="card-body-icons transaction-code-icon"></span>
            <span class="items-text">{{ 'selling.transaction_code' | translate }}:</span>
          </div>
          <div class="ml-10 user-data-text">{{ item.transactionCode }}</div>
        </div>
      }
      @if (item?.supportId) {
        <div class="item-row">
          <div class="item-wrapper w-145">
            <span class="card-body-icons support-icon"></span>
            <span class="items-text">{{ 'selling.support_identifier' | translate }}:</span>
          </div>
          <div class="ml-10 user-data-text">{{ item.supportId }}</div>
        </div>
      }
    </div>
  </div>

  @if (events?.length > 0) {
    <div class="item-divider"></div>
  }

  @for (event of events; track event; let last = $last) {
    @if ((item.cancellationReason && item.cancellationReason !== '')) {
      <div class="event-row">
        <div class="status-row" style="background-color: #F44346;">
          <span class="card-body-icons danger-icon"></span>
          <div class="event-status"> {{ "selling.title_canceled" | translate }} </div>
        </div>
        <div class="item-wrapper">
<!--           <span class="card-body-icons calendar-icon"></span>-->
          <span class="items-text">{{ item.cancellationReason }}</span></div>
      </div>
    }
    @if ((item.cancellationReason === null || item.cancellationReason === '')) {
      @if (event.status === 'B') {
        <div class="event-row">
          @if (event.title) {
            <div class="item-wrapper">
              <span class="card-body-icons seat-icon"></span>
              <span class="items-text">{{event.title}} </span>
            </div>
          }
          @if (event.eventStartDateTime) {
            <div class="item-wrapper">
              <span class="card-body-icons calendar-icon"></span>
              <span class="tems-text">
              {{ event.eventStartDateTime | localizedDate:'dd/MM/yyyy - HH:mm'}}
              </span>
            </div>
          }
          <div class="status-row bg-secondary">
            <span class="card-body-icons tick-icon"></span>
            <div class="event-status"> {{ "selling.title_in_blacklist" | translate }} </div>
          </div>
        </div>
      }
      @if (event.status === 'D') {
        <div class="event-row">
          @if (event.title) {
            <div class="item-wrapper">
              <span class="card-body-icons seat-icon"></span>
              <span class="items-text">{{event.title}} </span>
            </div>
          }
          @if (event.eventStartDateTime) {
            <div class="item-wrapper">
              <span class="card-body-icons calendar-icon"></span>
              <span class="tems-text">
              {{ event.eventStartDateTime | localizedDate:'dd/MM/yyyy - HH:mm'}}
              </span>
            </div>
          }
          <div class="status-row bg-secondary">
            <span class="card-body-icons tick-icon"></span>
            <div class="event-status"> {{ "selling.title_in_blacklist" | translate }} </div>
          </div>
        </div>
      }
      @if (event.status === 'F') {
        <div class="event-row">
          @if (event.title) {
            <div class="item-wrapper">
              <span class="card-body-icons seat-icon"></span>
              <span class="items-text">{{event.title}} </span>
            </div>
          }
          @if (event.eventStartDateTime) {
            <div class="item-wrapper">
              <span class="card-body-icons calendar-icon"></span>
              <span class="tems-text">
              {{ event.eventStartDateTime | localizedDate:'dd/MM/yyyy - HH:mm'}}
              </span>
            </div>
          }
          <div class="status-row bg-secondary">
            <span class="card-body-icons tick-icon"></span>
            <div class="event-status"> {{ "selling.title_in_blacklist" | translate }} </div>
          </div>
        </div>
      }
      @if (event.status === 'M') {
        <div class="event-row">
          @if (event.title) {
            <div class="item-wrapper">
              <span class="card-body-icons seat-icon"></span>
              <span class="items-text">{{event.title}} </span>
            </div>
          }
          @if (event.entryDateTime) {
            <div class="item-wrapper">
              <span class="card-body-icons calendar-icon"></span>
              <span class="tems-text">
              {{ event.entryDateTime | localizedDate:'dd/MM/yyyy - HH:mm'}}
              </span>
            </div>
          }
          <div class="status-row bg-primary" [ngStyle]="{'height': event.entryDateTime && isWebMobile ? '35px' : '24px'}">
            <span class="card-body-icons tick-icon"></span>
            <div class="event-status">
              {{ event.entryDateTime ? ('selling.access_used_date' | translate) : ('selling.access_used' | translate) }}
              {{ event.entryDateTime | localizedDate:'dd/MM/yyyy - HH:mm'}}
            </div>
          </div>
        </div>
      }
      @if (event.status === 'V') {
        <div class="event-row">
          @if (event.title) {
            <div class="item-wrapper">
              <span class="card-body-icons seat-icon"></span>
              <span class="items-text">{{event.title}} </span>
            </div>
          }
          @if (event.eventStartDateTime) {
            <div class="item-wrapper">
              <span class="card-body-icons calendar-icon"></span>
              <span class="tems-text">
              {{ event.eventStartDateTime | localizedDate:'dd/MM/yyyy - HH:mm'}}
              </span>
            </div>
          }
          <div class="status-row" style="background-color: #5EB47A;">
            <span class="card-body-icons tick-icon"></span>
            <div class="event-status"> {{ "general.valid_access" | translate }} </div>
          </div>
        </div>
      }
      @if (event.status === 'Z') {
        <div class="event-row">
          @if (event.title) {
            <div class="item-wrapper">
              <span class="card-body-icons seat-icon"></span>
              <span class="items-text">{{event.title}} </span>
            </div>
          }
          @if (event.eventStartDateTime) {
            <div class="item-wrapper">
              <span class="card-body-icons calendar-icon"></span>
              <span class="tems-text">
              {{ event.eventStartDateTime | localizedDate:'dd/MM/yyyy - HH:mm'}}
              </span>
            </div>
          }
          <div class="status-row bg-primary" [ngStyle]="{'height': event.entryDateTime && isWebMobile ? '35px' : '24px'}">
            <span class="card-body-icons tick-icon"></span>
            <div class="event-status">
              {{ event.entryDateTime ? ('selling.access_used_date' | translate) : ('selling.access_used' | translate) }}
              {{ event.entryDateTime | localizedDate:'dd/MM/yyyy - HH:mm'}}
            </div>
          </div>
        </div>
      }
    }
    @if (!last) {
      <div class="events-divider"></div>
    }
  }

</div>
